<template>
  <div class="index-container" ref="ref_scoll">

    <div class="header-container main">

      <!-- 轮播图 -->
      <swiper class="header_left" :options="banSwiperOption" v-if="bannerData.length>0">
        <swiper-slide v-for="(item,index) in bannerData" :key="index">
          <img :src="item.head_img" alt="">
          <div class="zhezhao" @click="toListDetail(item.id)">
            <h3>{{item.title}}</h3>
          </div>
        </swiper-slide>
        <div class="inappSwiperPage swiper-pagination" slot="pagination">
        </div>
      </swiper>

      <!-- 解决方案 -->
      <div class="header_right" v-if="casely.length>0">
        <div class="header_right_1">
          <h3>解决方案</h3>
          <span @click="toSolve(casely[0].category_id)">更多》</span>
        </div>
        <img v-if="casely[0]" @click="toInside(casely[0].id,casely[0].category_id)" :src="casely[0].litpic" alt="">
        <div class="header_right_3" @click="toInside(casely[0].id,casely[0].category_id)">
          <h5 v-if="casely[0]">{{casely[0].title}}</h5>
          <p><img src="https://oss.cloudcpc.com/new_jiant.png" alt=""></p>
        </div>
      </div>
    </div>

    <div class="indus-container main">
      <div class="indus_left">
        <!-- 行业先锋 -->
        <div class="vanguard_one" v-if="columnData[0]">
          <div class="real_top">
            <h3>
              <img src="" alt="">
              {{columnData[0].name}}
            </h3>
            <span @click="toList(columnData[0].category_id)">更多》&nbsp;</span>
          </div>
          <ul class="real_bottom" v-if="columnData[0].children.length>0">
            <li class="real_li" v-for="(item,index) in columnData[0].children" :key="index" @click="toListDetail(item.id)">
              <div class="real_liOne">
                <img :src="item.litpic" alt="">
              </div>
              <div class="real_liTwo">
                <h3>{{item.title}}</h3>
                <p>{{item.desc}}</p>
                <div>
                  <span>查看详情</span>
                  <img src="https://oss.cloudcpc.com/news_jian.png" alt="">
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- 汽车制造 -->
        <div class="vanguard_two" v-if="columnData[3] || columnData[4]">
          <div class="vang_top">
            <h3 class="vang_h3">
              <i></i>
              <span @click="carClick(0)" :class="[carIndex==0?'active':'']">{{columnData[3].name}}</span>
              <span @click="carClick(1)" :class="[carIndex==1?'active':'']">{{columnData[4].name}}</span>
            </h3>
            <span @click="toList(carIndex==0?columnData[3].category_id:columnData[4].category_id)">更多》&nbsp;</span>
          </div>

          <ul class="vang_bottom" v-if="carIndex==0?columnData[3].children.length>0:columnData[4].children.length>0">
            <li v-for="(item,index) in carIndex==0?columnData[3].children:columnData[4].children" :key="index" @click="toListDetail(item.id)">
              <img :src="item.litpic" alt="">
              <p>{{item.title}}</p>
            </li>
          </ul>
        </div>

        <!-- 新能源 -->
        <div class="vanguard_three" v-if="columnData[6] || columnData[7]">
          <div class="environ_top">
            <h3 class="environ_h3">
              <i></i>
              <span @click="energyClick(0)" :class="[energyIndex==0?'active':'']">{{columnData[6].name}}</span>
              <span @click="energyClick(1)" :class="[energyIndex==1?'active':'']">{{columnData[7].name}}</span>
            </h3>
            <span @click="toList(energyIndex==0?columnData[6].category_id:columnData[7].category_id)">更多》&nbsp;</span>
          </div>
          <ul class="real_bottom" v-if="energyIndex==0?columnData[6].children.length>0:columnData[7].children.length>0">
            <li v-for="(item,index) in energyIndex==0?columnData[6].children:columnData[7].children" :key="index" @click="toListDetail(item.id)" class="real_li">
              <div class="real_liOne">
                <img :src="item.litpic" alt="">
              </div>
              <div class="real_liTwo">
                <h3>{{item.title}}</h3>
                <p>{{item.desc}}</p>
                <span>发布时间：{{item.create_time}}</span>
              </div>
            </li>
          </ul>
        </div>

        <!-- 轨道交通 -->
        <div v-if="columnData[10]">
          <div class="vanguard_four" v-if="columnData[10].children.length>0" @click="toListDetail(columnData[10].children[0].id)">
            <div class="track_one">
              <img :src="columnData[10].children[0].litpic" alt="">
            </div>
            <div class="track_two">
              <i></i>
              <div class="trackDiv">
                <h4>{{columnData[10].name}}</h4>
                <span @click.stop="toList(columnData[10].category_id)">更多》&nbsp;</span>
              </div>
              <span>{{columnData[10].children[0].create_time}}</span>
              <h3>{{columnData[10].children[0].title}}</h3>
              <p>{{columnData[10].children[0].desc}}</p>
            </div>
          </div>
        </div>

      </div>

      <div class="indus_right">
        <!-- 石油化工 -->
        <div class="petro_one" v-if="columnData[1]">
          <h3>{{columnData[1].name}}</h3>
          <span></span>
          <ul class="currenUl" v-if="columnData[1].children.length>0">
            <li class="curren" v-for="(item,index) in columnData[1].children" :key="index" @click="toListDetail(item.id)">
              <i></i>
              <h4>
                <span></span>
                {{item.desc}}
              </h4>
              <h5>{{item.create_time}}</h5>
            </li>
          </ul>
          <div class="seel" @click="toList(columnData[1].category_id)">
            查看更多
          </div>
        </div>

        <!-- 航空航天 -->
        <div class="petro_two" v-if="columnData[2]">
          <h3>{{columnData[2].name}}</h3>
          <ul class="aviaUl" v-if="columnData[2].children.length>0">
            <li class="aviaLi" v-for="(item,index) in columnData[2].children" :key="index" @click="toListDetail(item.id)">
              <img :src="item.litpic" alt="">
              <p>{{item.title}}</p>
            </li>
          </ul>
          <div class="seel" @click="toList(columnData[2].category_id)">
            查看更多
          </div>
        </div>

        <!-- 工程建筑 -->
        <div class="petro_three" v-if="columnData[5]">
          <div class="enginTop">
            <h3>{{columnData[5].name}}</h3>
            <span @click="toList(columnData[5].category_id)">更多》&nbsp;&nbsp;</span>
          </div>
          <div class="enginBottom" v-if="columnData[5].children.length>0">
            <img :src="columnData[5].children[0].litpic">
            <a href="javascript:void(0)">
              <div class="mask" @click="toListDetail(columnData[5].children[0].id)">
                <h3>{{columnData[5].children[0].title}}</h3>
              </div>
            </a>
          </div>
        </div>

        <!-- IT科技 -->
        <div class="petro_four" v-if="columnData[8] || columnData[9]">
          <div class="compu_top">
            <h3 class="compu_h3">
              <span @click="itClick(0)" :class="[itIndex==0?'active':'']">{{columnData[8].name}}</span>
              <span @click="itClick(1)" :class="[itIndex==1?'active':'']">{{columnData[9].name}}</span>
            </h3>
            <span @click="toList(itIndex==0?columnData[8].category_id:columnData[9].category_id)">更多》&nbsp;</span>
          </div>
          <ul class="compuUl" v-if="itIndex==0?columnData[8].children.length>0:columnData[9].children.length>0">
            <li v-for="(item,index) in itIndex==0?columnData[8].children:columnData[9].children" :key="index" @click="toListDetail(item.id)" class="compuLi">
              <div class="compuOne">
                <img :src="item.litpic" alt="">
                <span>{{item.title}}</span>
              </div>
              <div class="compuTwo">{{item.desc}}</div>
            </li>
          </ul>
        </div>

        <!-- 包装印刷 -->
        <div class="petro_three" v-if="columnData[11]">
          <div class="enginTop">
            <h3>{{columnData[11].name}}</h3>
            <span @click="toList(columnData[11].category_id)">更多》&nbsp;&nbsp;</span>
          </div>
          <div class="enginBottom" v-if="columnData[11].children.length>0">
            <img :src="columnData[11].children[0].litpic">
            <a href="javascript:void(0)">
              <div class="mask" @click="toListDetail(columnData[11].children[0].id)">
                <h3>{{columnData[11].children[0].title}}</h3>
              </div>
            </a>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
/* eslint-disable no-new */
import Swiper from "swiper";
import { WOW } from "wowjs";
import { getCate, getZixunAll, getArt, getCase } from "../api/index";

export default {
  name: "news",
  data() {
    return {
      //默认新能源
      energyIndex: 0,
      //默认汽车栏目
      carIndex: 0,
      //默认IT栏目
      itIndex: 0,
      //banner数据
      bannerData: [],
      //解决方案
      casely: [],
      //栏目
      columnData: [],
      banSwiperOption: {
        pagination: ".swiper-pagination",
        paginationClickable: true,
        // spaceBetween: 45,
        // slidesPerView: 3, // 这个地方可以设置为小数
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        loop: false, // 循环播放
        initialSlide: 0, // 默认第一页
        autoplay: 5000,
        // autoplayDisableOnInteraction: false
      },
    };
  },
  beforeDestroy() {
    $("#xunId").removeClass("on active").removeAttr("aria-current", "page");
  },
  mounted() {
    $("#xunId").addClass("on active").attr("aria-current", "page");
    /** SEO start */
    // seo_title
    document.getElementById("seo_title").innerHTML = "资讯专区-国机集团武汉纺友";
    // seo_keywords
    document.getElementById("seo_keywords").content = "资讯专区,国机集团,武汉纺友";
    // seo_description
    document.getElementById("seo_description").content = "资讯专区,国机集团,武汉纺友";
    /** SEO end */

    //快速读取
    this.readData();
    //存储数据
    // this.getZixunAllData();

    this.$nextTick(() => {
      let wow = new WOW({
        boxClass: "wow", /// 动画元件css类（默认为wow）
        animateClass: "animated", // 动画css类（默认为animated）
        offset: 0, // 到元素距离触发动画（当默认为0）
        mobile: true, // 在移动设备上触发动画（默认为true）
        live: true, // 对异步加载的内容进行操作（默认为true）
      });
      // wow.start()
      wow.init();
      if (document.getElementsByClassName("wow_show").length > 0) {
        if (window.scrollY !== 0) return;
        for (
          let index = 0;
          index < document.getElementsByClassName("wow_show").length;
          index++
        ) {
          wow.show(document.getElementsByClassName("wow_show")[index]);
        }
      }
    });
  },
  watch: {},
  methods: {
    //切换栏目
    carClick(e) {
      this.carIndex = e;
    },
    energyClick(e) {
      this.energyIndex = e;
    },
    itClick(e) {
      this.itIndex = e;
    },
    //跳转到资讯详情
    toListDetail(id) {
      this.$store.commit("SET_NAVALLINDEX", 4);
      sessionStorage.setItem("navIndex", JSON.stringify(4));
      // this.$router.push({ path: "/listDetail", query: { id: id } });
      var routeUrl = this.$router.resolve({
        path: "/listDetail",
        query: { id: id },
      });
      window.open(routeUrl.href, "_blank");
    },
    //跳转案例详情
    toInside(id, category_id) {
      //跳转内页
      this.$store.commit("SET_NAVALLINDEX", 4);
      sessionStorage.setItem("navIndex", JSON.stringify(4));
      var routeUrl = this.$router.resolve({
        path: "/inside",
        query: { id: id, category_id: category_id },
      });
      window.open(routeUrl.href, "_blank");
    },
    //快速存入读取资讯总数据
    readData() {
      //这样写的话有缓存的时候页面刷新走的是缓存
      if (sessionStorage.getItem("wholeData")) {
        var res = JSON.parse(sessionStorage.getItem("wholeData"));
        console.log(res);
        this.bannerData = res.toutiao;
        this.casely = res.casely;
        this.columnData = res.infos;
      } else {
        getZixunAll().then((res) => {
          // console.log(res);
          // 服务器卡顿，修改至进入首页时就存入会话存储
          sessionStorage.setItem("wholeData", JSON.stringify(res));
          this.bannerData = res.toutiao;
          this.casely = res.casely;
          this.columnData = res.infos;
        });
      }
    },
    //点击跳转解决方案
    toSolve(category_id) {
      this.$store.commit("SET_NAVALLINDEX", 4);
      sessionStorage.setItem("navIndex", JSON.stringify(4));
      var routeUrl = this.$router.resolve({
        path: "/cases",
        query: { category_id: category_id },
      });
      window.open(routeUrl.href, "_blank");
    },
    //点击跳转资讯列表
    toList(category_id) {
      this.$store.commit("SET_NAVALLINDEX", 4);
      sessionStorage.setItem("navIndex", JSON.stringify(4));
      var routeUrl = this.$router.resolve({
        path: "/inforlist",
        query: { category_id: category_id },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "assets/style/news.scss";
.inappSwiperPage .swiper-pagination-bullet {
  background: #d6dee9 !important;
}
/deep/.inappSwiperPage {
  bottom: 24px !important;
  left: 280px !important;
  .swiper-pagination-bullet {
    width: 35px;
    height: 3px;
    background: #d6dee9;
    opacity: 1;
    border-radius: 0;
  }
  .swiper-pagination-bullet-active {
    background: linear-gradient(-36deg, #0071ff 0%, #318cff 100%);
  }
}
</style>
